import { FETCH_CMSPAGE_FULFILLED, FETCH_CMSPAGE_REJECTED } from '../actions/getCmsPage';
import { CLEAR_CMSPAGE } from '../actions/clearCmsPage';

export default function (state: any = {}, action: any) {
  const switchCase = (action.meta?.pageUrl === '/page-not-found' || action.payload?.response?.data?.pageURL === '/page-not-found')
  ? FETCH_CMSPAGE_REJECTED : FETCH_CMSPAGE_FULFILLED;
  switch (action.type) {
    case switchCase:
      return {
        ...state,
        [`${action.meta.pageUrl}-${action.meta.language}`]:
          action?.payload?.data || action?.payload?.response?.data || {},
      };
    case CLEAR_CMSPAGE:
      return {};
    default:
      return state;
  }
}
